import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

const Bitrix24Modal = ({ isOpen, onClose }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (isOpen && containerRef.current) {
      // Create script element
      const script = document.createElement('script');
      script.setAttribute('data-b24-form', 'inline/2/nmb8gm');
      script.setAttribute('data-skip-moving', 'true');
      script.text = `(function(w,d,u){var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://cdn.bitrix24.com/b3225757/crm/form/loader_2.js');`;
      
      containerRef.current.appendChild(script);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-2xl bg-white rounded-lg shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white shadow-lg hover:bg-gray-100 transition-colors duration-200"
          aria-label="Cerrar"
        >
          <X size={24} className="text-gray-600" />
        </button>

        <div 
          ref={containerRef}
          className="p-8 max-h-[80vh] overflow-y-auto"
        />
      </div>
    </div>
  );
};

export default Bitrix24Modal;
